import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBClient {
  // 客户列表
  getClientList(options) {
    let url = `/api/db/cus/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 客户标签列表
  getClientTagList() {
    let url = `/api/db/cus/label/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 增加客户标签
  addClientTag(data) {
    const url = `/api/db/cus/label/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改有的客户标签
  updateClientTag(data) {
    const url = `/api/db/cus/label/update`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 删除现有的标签
  deleteClientTag(data) {
    const url = `/api/db/cus/label/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 新增客户--大b添加小B
  addClient(data) {
    const url = `/api/db/cus/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 新增客户标签--给某个客户新加标签
  addTagForClient(data) {
    const url = `/api/db/cus/xb/label/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 更新某个用户状态
  updateClientStatus(data) {
    const url = `/api/db/cus/user/status/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 根据xbId获取客户详情
  getCustomerDetailById(xbId) {
    const url = `/api/db/cus/detail?xbId=${xbId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改客户详情
  updateCustomerDetail(data) {
    const url = `/api/db/cus/detail/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 重置密码
  resetClientPassword(data) {
    const url = `/api/db/cus/pass/reset`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 添加客户等级
  postAddClientGrade(data) {
    const url = `/api/db/cus/level/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改客户等级
  postUpdateClientGrade(data) {
    const url = `/api/db/cus/level/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取客户等级列表
  getClientGradeList() {
    const url = `/api/db/cus/level/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 删除客户等级
  getDeleteClientGrade(id) {
    const url = `/api/db/cus/level/delete?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 发送短信
  getSendShortMsg(options) {
    let url = `/api/common/back/send/code/fore?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改客户绑定的手机号
  postModifyPhone(data) {
    const url = `/api/db/cus/update/telephone`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取某个客户优惠券领取情况（只展示可以用的）
  getClientCouponList(xbId) {
    const url = `/api/db/coupon/unit/cus/receive/info?xbId=${xbId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 客户对应的积分
  getClientPoints(userId) {
    const url = `/api/db/points/xb/points/info?userId=${userId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 登录统计
  getLoginStatistics(options) {
    let url = `/api/db/cus/login/statistics?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBClient
